import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { SessionBaseComponent } from '../../session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasOption } from 'src/app/core/models/laas-option';
import { LogisticsTenantOrgService } from 'src/app/core/services/logistics/tenant-org/logistics-tenant-org.service';
import { deepCopy, getOrgIdByPermission } from 'src/app/core/utils/common-functions';
import { UserType } from 'src/app/core/enums/user-type.enum';

@Component({
  selector: 'laas-tenant-org-dropdown',
  templateUrl: './tenant-org-dropdown.component.html',
  styleUrls: ['./tenant-org-dropdown.component.scss']
})
export class TenantOrgDropdownComponent extends SessionBaseComponent implements OnInit {

  @Input() divClass: string = '';
  @Input() labelClass: string = '';
  @Input() dropdownStyle: any = {};
  @Input() showLabel: boolean = false;
  @Input() showClear: boolean = true;
  @Input() showFilter: boolean = true;
  @Input() permissionCode!: PermissionConstants;
  @Input() isSingle: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() showToggleAll: boolean = false;
  @Input() formControlName: string = '';
  @Input() showAllOptionItem: boolean = false;
  @Input() tenantOrgDataList: any[] = [];
  @Input() tenantOrgData: any;

  @Output() onOptionDataChange: EventEmitter<any>  = new EventEmitter();

  virtualScroll: boolean = false;
  tenantOrgOptions: LaasOption[] = [];
  tenantOrgOptionsByPermission: LaasOption[] = [];
  allOptionItem: LaasOption = {
    value: "ALL",
    label: "ALL - 全部"
  };

  constructor (
    injector: Injector,
    private logisticsTenantOrgService: LogisticsTenantOrgService,
    ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    this.logisticsTenantOrgService.getTenantOrgOptions().subscribe({
      next: (options: any[]) => {
        const tenantOrgByPermission = getOrgIdByPermission(this.userProfile, this.permissionCode);
        const isAllNull = tenantOrgByPermission.every((x: any) => x == null);
        const tenantOrgOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || tenantOrgByPermission.includes(x.orgId));
        this.tenantOrgOptionsByPermission = (deepCopy(tenantOrgOptionsByPermission) as any[]).map(x => ({ value: x.orgId, label: `${x.orgId} - ${x.orgName}` }));
      }
    });

  }

  async onChange(event: any): Promise<void> {
    this.onOptionDataChange.emit(event);
  }

}
